import { ConversationMessage, MessageWithObservability } from '../../../types';

// Query key for a conversation's message list (ADR-0049). The streaming and
// websocket hooks append to this same cache entry via setQueryData, so the key
// factory is shared rather than re-derived per call site.
export const chatMessageKeys = {
  list: (customerId?: string, sessionId?: string) =>
    ['chat', 'messages', customerId ?? null, sessionId ?? null] as const,
};

// Normalizes a loaded conversation (history API) into the message shape the chat
// renders. Shared by the query hook that loads history and any caller that seeds
// the cache.
export function mapConversationToMessages(
  conversation: ConversationMessage[],
  sessionId: string
): MessageWithObservability[] {
  return conversation.map((turn, index) => ({
    id: turn.id || `msg-loaded-${index}`,
    content: turn.content || '',
    role: turn.role || 'assistant',
    timestamp: turn.timestamp || new Date().toISOString(),
    investigation_id: turn.investigation_id || sessionId,
    observability: turn.observability,
    blocks: turn.blocks,
    // Reattached server-side from the persisted turn records, so a reloaded
    // conversation keeps the token footer the live turn showed.
    token_usage: turn.token_usage,
  }));
}
